export default class MembershipStatusAbstractServices {
  static getReferenceData() {
    logger.error('MembershipStatus:: getReferenceData() not implemented');
  }

  static async getProrataPrice(memberNumber, payload) {
    logger.error(`MembershipStatus:: getProrataPrice(${memberNumber}, ${payload}) not implemented`);
  }

  static async getPremiumAdjustments(memberNumber, showPremiumPaymentAmount, coverStartDate, startDateCatchUp) {
    logger.error(`MembershipStatus:: getPremiumAdjustments(${memberNumber}, ${showPremiumPaymentAmount}, ${coverStartDate}, ${startDateCatchUp}) not implemented`);
  }

  static async payNow(cardToken, amount, fail) {
    logger.error(`MembershipStatus:: payNow(${cardToken}, ${amount}, ${fail}) not implemented`);
  }
}
